module.exports = __webpack_public_path__ + "static/media/logo-facebook.50aca038.svg";